import React from 'react'
import Img1 from '@resources/imgs/home/about/1.jpg'
import Img2 from '@resources/imgs/home/about/2.jpg'
import Img3 from '@resources/imgs/home/about/3.jpg'
import Img4 from '@resources/imgs/home/about/4.jpg'
import Img5 from '@resources/imgs/home/about/5.png'
import Img6 from '@resources/imgs/home/about/6.jpg'
import Carousel from 'react-slick'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import './AboutSection.css'
import { LuArrowLeft, LuArrowRight } from 'react-icons/lu'

const cards = [
  {
    image: Img1,
    category: 'Qualidade & Segurança',
    description: 'Triagem rigorosa, exames avançados e qualidade premium, certificados pela ANVISA e CFM, garantindo proteção e tranquilidade.',
  },
  {
    image: Img2,
    category: 'Melhores Bancos Internacionais',
    description: 'Representação exclusiva dos bancos mais renomados da Europa e Estados Unidos, com amostras de doadores importados à pronta entrega.',
  },
  {
    image: Img3,
    category: 'Atendimento Personalizado',
    description: 'Apoio humanizado e especializado para a escolha do doador ideal, incluindo os serviços gratuítos do Photomatching e consultorias.',
  },
  {
    image: Img4,
    category: 'Entrega em até 48h',
    description: 'Envio de amostras de sêmen com o prazo de entrega mais rápido do mercado para clínicas parceiras em todo o Brasil.',
  },
  {
    image: Img5,
    category: 'Aconselhamento Genético Gratuito',
    description: 'Uma consulta com geneticista especializada para esclarecer as suas dúvidas e otimizar a sua escolha.',
  },
  {
    image: Img6,
    category: 'Photomatching Humanizado',
    description: 'O olhar humano, treinado e dedicado da nossa equipe para encontrar seu doador, identificando semelhanças físicas entre ele e sua referência.',
  },
]

const PrevArrow = ({ onClick }: any) => (
  <button
    type="button"
    className="about-nav-arrow"
    onClick={onClick}
    aria-label="Anterior"
  >
    <LuArrowLeft size={16} />
  </button>
)

const NextArrow = ({ onClick }: any) => (
  <button
    type="button"
    className="about-nav-arrow"
    onClick={onClick}
    aria-label="Próximo"
  >
    <LuArrowRight size={16} />
  </button>
)

const AboutSection: React.FC<any> = () => {
  const settings = {
    arrows: true,
    dots: true,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  }

  return (
    <section className="about-section">
      <div className="d-flex align-items-center justify-content-between mb-4">
        <div>
          <span
            className="about-kicker d-block font-weight-bold text-uppercase mb-1"
            style={{ color: '#FA5A84' }}
          >
            Por que escolher o Pro-Seed?
          </span>

          <h2 className="about-title font-weight-bold text-dark mb-0">
            O melhor e mais completo Banco de Sêmen do Brasil
          </h2>
        </div>
      </div>

      <Carousel {...settings}>
        {cards.map(({ image, category, description }, index) => (
          <div key={`card-${category}-${index}`} className="px-2">
            <div
              className="about-card w-100 bg-white overflow-hidden"
              style={{
                borderRadius: 16,
                boxShadow: '0 1px 8px rgba(0,0,0,0.07)',
                margin: '0 auto',
              }}
            >
              <div
                className="about-card-img-wrapper overflow-hidden position-relative"
                style={{ height: 220 }}
              >
                <img
                  src={image}
                  alt={category}
                  className="w-100 h-100 about-card-img"
                  style={{ objectFit: 'cover' }}
                />

                <div
                  className="position-absolute w-100 h-100"
                  style={{
                    top: 0,
                    left: 0,
                    background:
                      'linear-gradient(to bottom, transparent 40%, #ffffff 100%)',
                    pointerEvents: 'none',
                  }}
                />
              </div>

              <div className="p-4">
                <p
                  className="font-weight-bold mb-1"
                  style={{ color: '#FA5A84', fontSize: '1rem' }}
                >
                  {category}
                </p>

                <p
                  className="text-muted mb-0"
                  style={{ fontSize: '0.875rem', lineHeight: '1.5rem', minHeight: '96px' }}
                >
                  {description}
                </p>
              </div>
            </div>
          </div>
        ))}
      </Carousel>
    </section>
  )
}

export default AboutSection